import React, { useEffect, useState } from "react";
import { Typography, Grid, Button, styled, Box, Chip } from "@mui/material";
import { Divider, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import moment from "moment";
import {
  getCurrentUser,
  getSubjectAssignments,
  hasPermission,
  isTeacher,
} from "../../service/authService";

const MyCustomButton = styled(Button)(({ theme }) => ({
  fontFamily: "Motiva Sans Bold",
  fontSize: "0.80rem",
  fontWeight: "700",
  border: "1px solid #edf3f5",
  borderRadius: "4px",
  background: "#09829d",
  boxShadow: "0 16px 30px rgb(23 31 114 / 20%)",
  marginTop: "1rem",
  "&:hover": {
    color: "#fff",
    border: "1px solid rgb(255, 130, 92)",
    backgroundColor: "rgb(255, 130, 92)",
  },
}));

const PaperCard = (props: any) => {
  return (
    <Paper
      sx={{
        boxShadow: "0 3px 5px 2px rgba(0, 0, 0, .3)",
        position: "relative",
        borderRadius: 2,
        padding: 2,
        width: "85%", // Take full width of Grid item
        maxWidth: 360, // Restrict max width
        mx: "auto", // Center horizontally
      }}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography variant="h5">
            <strong>{props.title}</strong>
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {props.caption}
          </Typography>
        </Grid>

        <Divider sx={{ my: 1, borderColor: "#FF825B" }} />

        <Grid item>
          <Box display="flex" justifyContent="flex-start">
            <MyCustomButton
              type="button"
              variant="contained"
              size="medium"
              endIcon={<ArrowCircleRightIcon />}
              onClick={props.onClick}
              disabled={props.disabled || false}
            >
              <strong>{"Proceed"}</strong>
            </MyCustomButton>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

const SchoolAdmin: React.FC = () => {
  const navigate = useNavigate();
  // const [quote, setQuote] = useState("");

  // useEffect(() => {
  //   fetch("https://zenquotes.io/api/random")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setQuote(data[0].q + " - " + data[0].a);
  //     });
  // }, []);

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  const [classSubjectassignments, setClassSubjectassignments] = useState<any>();
  const [loggedInUsername, setLoggedInUsername] = useState<any>(undefined);

  useEffect(() => {
    if (isTeacher()) {
      console.log("***** subjectAssignment *********");
      const subjectAssignment = getSubjectAssignments();
      console.log(subjectAssignment);

      if (subjectAssignment) {
        const summaryMap = new Map();

        for (const a of subjectAssignment) {
          const key = `${a.class_id}-${a.section_id}`;

          if (!summaryMap.has(key)) {
            summaryMap.set(key, {
              class_id: a.class_id,
              class_name: a.class_name,
              section_id: a.section_id,
              section_name: a.section_name,
              subjects: new Set(),
            });
          }

          summaryMap.get(key).subjects.add(a.subject_name);
        }

        const class_section_subject_assignment = Array.from(
          summaryMap.values()
        ).map((entry) => ({
          ...entry,
          subjects: Array.from(entry.subjects),
        }));

        console.log("***** class_section_subject_assignment *********");
        console.log(class_section_subject_assignment);
        setClassSubjectassignments(class_section_subject_assignment);
      } else {
        setClassSubjectassignments([]);
      }
    }
    const user = getCurrentUser();
    setLoggedInUsername(user.name || undefined);
  }, []);

  const onMyPatymentsClick = () => {
    //props.onClick();
  };
  const getGreeting = () => {
    if (isTeacher()) {
      return "TEACHER DASHBOARD";
    } else {
      return "ADMIN DASHBOARD";
    }
  };

  return (
    <>
      <Grid container spacing={2} justifyContent="center" mb={1}>
        <Box width="100%" px={{ xs: 2, sm: 4 }} mt={1}>
          <Typography
            variant="h4"
            textAlign="center"
            sx={{
              color: "#2E186A",
              mt: 2,
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
            }}
          >
            <strong>WELCOME TO {getGreeting()}</strong>
          </Typography>

          {loggedInUsername && (
            <Typography
              variant="h4"
              textAlign="center"
              sx={{
                color: "#f47655",
                mt: 2,
                fontSize: { xs: "1rem", sm: "1rem", md: "1.5rem" },
              }}
            >
              <strong>{loggedInUsername}</strong>
            </Typography>
          )}
          {classSubjectassignments && classSubjectassignments.length > 0 && (
            <Box
              sx={{
                mt: 1,
                mb: 2,
                mx: "auto",
                width: "auto",
                maxWidth: "95%",
                border: "1px dashed #ccc",
                borderRadius: 2,
                p: 1,
                backgroundColor: "#fdfdfd",
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {classSubjectassignments.map((item: any, idx: any) => (
                <Chip
                  key={idx}
                  label={`Class ${item.class_name}-${
                    item.section_name
                  }: ${item.subjects.join(", ")}`}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
          )}
        </Box>

        {hasPermission("Fees Collection") && (
          <Grid item xs={12} sm={6} md={4}>
            <PaperCard
              title="Fees Collection"
              caption="View Fees Record. Collect Fees"
              onClick={() => navigate("fees-details")}
            />
          </Grid>
        )}

        {hasPermission("Students Management") && (
          <Grid item xs={12} sm={6} md={4}>
            <PaperCard
              title="Students Management"
              caption="View, Edit and Add Students here"
              onClick={() => navigate("students-management")}
            />
          </Grid>
        )}

        {hasPermission("Exams Management") && (
          <Grid item xs={12} sm={6} md={4}>
            <PaperCard
              title="Exams Management"
              caption="Configure and Schedule Exams"
              onClick={() => navigate("exams-management")}
            />
          </Grid>
        )}

        {hasPermission("Teachers Management") && (
          <Grid item xs={12} sm={6} md={4}>
            <PaperCard
              title="Teachers Management"
              caption="View and Manage Teacher, Subjects Assignment"
              onClick={() => navigate("staff-management")}
            />
          </Grid>
        )}

        {hasPermission("Report Center") && (
          <Grid item xs={12} sm={6} md={4}>
            <PaperCard
              title="Report Center"
              caption="Fee Collection, Dues, Performance Report"
              onClick={() => navigate("report-center")}
            />
          </Grid>
        )}

        {hasPermission("Control and Settings") && (
          <Grid item xs={12} sm={6} md={4}>
            <PaperCard
              title="Control and Settings"
              caption="Configure Subjects, Fees and Transport"
              onClick={() => navigate("controls-settings")}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default SchoolAdmin;
